import { FC } from 'react';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectSortedQuestions } from 'store/quiz/quizSelectors';
// Models
import IQuestion from 'models/Question';
// Components
import QuestionItem from './QuestionItem';

const QuestionsList:FC = () => {
  const questions = useAppSelector(selectSortedQuestions);

  const showQuestion = questions.length > 1;

  return (
    <div>
      {questions.map((question:IQuestion) => (
        <QuestionItem
          key={question.ref}
          question={question}
          showQuestion={showQuestion}
        />
      ))}
    </div>
  )
}

export default QuestionsList;
